import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const previewInput = z.object({
	preview: z.boolean(),
	token: z
		.string()
		.max(4096)
		.regex(/^[A-Za-z0-9_-]+$/)
		.optional(),
});

// Fetch and parse together: client navigation must not download an HTML parser
// or send administrator markup back to the server for a second request.
// Generated CMS JSON models are recursive (rich text -> blocks -> rich text),
// exceeding Start's structural output validation. Keep input validation strict;
// the output retains the loader's inferred model types and is exercised over RPC.
export const getLayoutData = createServerFn({
	method: "POST",
	strict: { output: false },
})
	.validator(previewInput)
	.handler(async ({ data }) => {
		const { loadLayoutData } = await import("./layout-data.server");
		return loadLayoutData(data);
	});
